/* eslint-disable camelcase */
import React from 'react';
import PropTypes, {arrayOf, bool, func} from 'prop-types';
import {ic_local_offer} from 'react-icons-kit/md/ic_local_offer';
import Icon from '@sinclair-digital/sbg-storyline-components/src/components/Icon';
import {SidebarLink as Link} from '@sinclair-digital/sbg-storyline-components/src/components/Sidebar';
import classNames from 'classnames';
import styles from './MediaTags.scss';
import {MediaTagsRightPanel} from './MediaTagsRightPanel';

/**
 * Sidebar Link which contains the list of tag that added to current video
 *
 * tags: object[];         list of tags
 * isEditable: bool        media is editable if it is the original and the user has access to the media
 * @param {Object} props
 * @returns {JSX.Element}
 * @constructor
 */
export const MediaTagsSidebarItem = (props) => {
    const [isPanelOpen, setIsPanelOpen] = React.useState(false);
    return (
        props?.tags?.length > 0 ? <>
            <Link
                icon={<Icon icon={ic_local_offer} size={22} />}
                onClick={() => setIsPanelOpen(true)}
                className={classNames(styles.mediaTagsSidebarItem)}
            >
                <div>Media Tags</div>
                <div className={styles.tagsNumber}>View tags ({props?.tags?.length || 0} tags)</div>
            </Link>
            <MediaTagsRightPanel
                isOpen={isPanelOpen}
                isEditable={props?.isEditable}
                tagExcludes={props?.tagExcludes}
                tags={props?.tags}
                closePanel={() => setIsPanelOpen(false)}
                onSave={() => undefined} />
        </> : undefined
    );
};

MediaTagsSidebarItem.propTypes = {
    onSave: func.isRequired,
    isEditable: bool,
    tags: arrayOf({
        name: PropTypes.string,
        dimension: PropTypes.string,
        uuid: PropTypes.string,
        relevance: PropTypes.number,
        included: PropTypes.bool,
        removable: PropTypes.bool,
        userGenerated: PropTypes.bool,
        position: PropTypes.number,
    }).isRequired,
    tagExcludes: arrayOf({
        name: PropTypes.string,
        dimension: PropTypes.string,
        uuid: PropTypes.string,
        relevance: PropTypes.number,
        included: PropTypes.bool,
        removable: PropTypes.bool,
        userGenerated: PropTypes.bool,
        position: PropTypes.number,
    }),
};
